import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X, ImagePlus } from "lucide-react";
import api, { apiError } from "@/lib/api";

export function LogoUpload({ value, onChange }) {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
      toast.success("Logo caricato");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div className="flex items-center gap-4">
      <div className="w-20 h-20 rounded-2xl border border-navy/10 bg-cream flex items-center justify-center overflow-hidden shrink-0">
        {value ? <img src={value} alt="logo" className="w-full h-full object-cover" /> : <ImagePlus className="w-7 h-7 text-navy/30" />}
      </div>
      <div>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={upload} data-testid="logo-file-input" />
        <button onClick={() => inputRef.current?.click()} disabled={loading}
          className="inline-flex items-center gap-2 rounded-full bg-navy text-white px-4 py-2 text-sm" data-testid="logo-upload-btn">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Carica logo
        </button>
        {value && <button onClick={() => onChange("")} className="ml-2 text-sm text-errortext">Rimuovi</button>}
      </div>
    </div>
  );
}

export function PhotosUpload({ value = [], onChange }) {
  const inputRef = useRef();
  const [loading, setLoading] = useState(false);
  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setLoading(true);
    try {
      const urls = [...value];
      for (const file of files) {
        const fd = new FormData();
        fd.append("file", file);
        const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
        urls.push(data.url);
      }
      onChange(urls);
      toast.success("Foto caricate");
    } catch (err) { toast.error(apiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };
  return (
    <div>
      <div className="flex flex-wrap gap-3">
        {value.map((u, i) => (
          <div key={i} className="relative w-24 h-24 rounded-xl overflow-hidden border border-navy/10">
            <img src={u} alt="" className="w-full h-full object-cover" />
            <button onClick={() => onChange(value.filter((_, idx) => idx !== i))}
              className="absolute top-1 right-1 w-6 h-6 rounded-full bg-black/60 text-white flex items-center justify-center"><X className="w-3.5 h-3.5" /></button>
          </div>
        ))}
        <button onClick={() => inputRef.current?.click()} disabled={loading}
          className="w-24 h-24 rounded-xl border-2 border-dashed border-navy/20 flex flex-col items-center justify-center text-navy/40 hover:border-orange" data-testid="photos-upload-btn">
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <><ImagePlus className="w-5 h-5" /><span className="text-[11px] mt-1">Aggiungi</span></>}
        </button>
      </div>
      <input ref={inputRef} type="file" accept="image/*" multiple className="hidden" onChange={upload} data-testid="photos-file-input" />
    </div>
  );
}
